/** L'indirizzo che apre WhatsApp col messaggio già scritto. Con il cellulare (anche «+39…») sulla chat
 *  dell'amministratore; senza, WhatsApp fa scegliere a chi mandarlo. */
export function indirizzoWhatsApp(cellulare: string | null, testo: string): string {
  const numero = (cellulare ?? "").replace(/\D/g, "");
  return `https://wa.me/${numero}?text=${encodeURIComponent(testo)}`;
}
